export default function PageOverlay() {
  return (
    <>
      <div
        className="fixed top-0 left-0 h-full w-[2px] md:w-[3px] z-[100] pointer-events-none"
        style={{
          background: 'linear-gradient(to bottom, transparent 0%, rgba(139,69,19,0.08) 10%, rgba(139,69,19,0.15) 50%, rgba(139,69,19,0.08) 90%, transparent 100%)',
        }}
      />
      <div
        className="fixed top-0 right-0 h-full w-[2px] md:w-[3px] z-[100] pointer-events-none"
        style={{
          background: 'linear-gradient(to bottom, transparent 0%, rgba(139,69,19,0.08) 10%, rgba(139,69,19,0.15) 50%, rgba(139,69,19,0.08) 90%, transparent 100%)',
        }}
      />
    </>
  );
}